import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from '../base/base.service';
import { ObjectApiInterface } from '../base/interfaces/object-api.interface';
import { AddressModel } from '../models/address.model';
import { Country } from '../enums/countries.enum';
import { AuthService } from './auth.service';

export interface AddressStatistics {
  total: number;
  active: number;
  inactive: number;
  byCountry: { _id: string; count: number }[];
}

@Injectable({
  providedIn: 'root',
})
export class AddressService extends BaseService<AddressModel> {
  defaultSort = 'createdAt';

  protected _addresses = new BehaviorSubject<AddressModel[]>([] as AddressModel[]);
  readonly addresses$ = this._addresses.asObservable();

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'address', authService);
  }

  /**
   * Valide un code postal
   */
  validatePostalCode(postalCode: string, country: Country): Observable<ObjectApiInterface<{ isValid: boolean }>> {
    const params = new HttpParams().set('postalCode', postalCode).set('country', country);

    return this.http.get<
      ObjectApiInterface<{
        isValid: boolean;
      }>
    >(`${this.baseUrlApi}/validate-postal-code`, { params });
  }

  /**
   * Vérifie les dépendances d'une adresse avant suppression
   */
  checkDependencies(address: AddressModel): any {
    return this.http.post<ObjectApiInterface<{ dependencies: any }>>(`${this.baseUrlApi}/check-dependencies`, {
      _id: address._id,
    });
  }

  /**
   * Supprime une adresse avec le buildingId pour retirer l'ID du tableau buildingIds
   */
  deleteAddress(addressId: string, buildingId: string): Observable<ObjectApiInterface<boolean>> {
    return this.http.delete<ObjectApiInterface<boolean>>(
      `${this.baseUrlApi}/delete/${addressId}?buildingId=${buildingId}`,
    );
  }
}
